import IconCancel from '@pages/Payment/Components/IconCancel'
import { Modal } from 'antd'
import React, { FC } from 'react'
import { IResponeKLB } from '../../../../types/general'
import DownloadQrImage from './DownloadQrImage'
import QrExpiryNotice from './QrExpiryNotice'

interface IProps {
  img?: IResponeKLB | undefined
  isModalOpen: boolean
  expiresAtMs?: number
  isSkipSelectBill?: boolean
  setIsModalOpen: (value: boolean) => void
}

const ModalKLB: FC<IProps> = ({ isModalOpen, img, setIsModalOpen, expiresAtMs }: IProps) => {
  const handleOk = () => {
    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <Modal
        title={<></>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={<></>}
        className="p-0 custom-modal rouder-31"
      >
        <div className="border-[25px] border-[#045993] rounded-[20px] px-[12px] py-[16px]">
          <div className="relative items-center flex flex-col justify-center rounded-[20px] ">
            <span className="absolute right-[-8px] top-[-8px]">
              <IconCancel
                handleCancel={() => {
                  handleCancel()
                }}
              />
            </span>
            {/* <img src={require('@assets/icon/KLB2.png')} alt="" className="w-[200px] h-full" /> */}
            <div className="border-[1px] border-[#151515] my-[8px] mt-[36px] mx-[12px]">
              <img src={`${img?.qrLink}`} alt="" className="mx-auto w-full " />
            </div>
            <DownloadQrImage imageSrc={img?.qrLink} fileName="klb-qr-thanh-toan.png" />
            <QrExpiryNotice
              isModalOpen={isModalOpen && !!img?.qrLink}
              paymentChannel="KLB"
              resetKey={img?.transactionCode}
              expiresAtMs={expiresAtMs}
            />
          </div>
        </div>
      </Modal>
    </>
  )
}
export default ModalKLB
